"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeBorderRadiusShorthand = exports.openBorderRadiusShorthand = void 0;
var tslib_1 = require("tslib");
var css_data_types_1 = require("../../css-data-types");
var tokenizers_1 = require("../../tokenizers");
var shorthand_parser_utils_1 = require("../shorthand-parser-utils");
// border-radius
var openBorderRadiusShorthand = function () {
    var singleBorderRadiusShorthandOpenerInner = (0, shorthand_parser_utils_1.edgesShorthandOpener)('border-radius', true);
    var borderRadiusShorthandOpener = (0, shorthand_parser_utils_1.createShorthandOpener)({
        prop: 'border-radius',
        parts: [
            {
                prop: 'border-radius',
                dataType: css_data_types_1.ALWAYS_DATA_TYPE,
                openedProps: [
                    'border-top-left-radius',
                    'border-top-right-radius',
                    'border-bottom-right-radius',
                    'border-bottom-left-radius',
                ],
            },
        ],
        shorthandOpener: function (astNodes, api) {
            var e_1, _a;
            var _b = tslib_1.__read((0, shorthand_parser_utils_1.getShorthandLayers)(astNodes, css_data_types_1.INTERNAL_VALUE_SEPERATOR), 2), firstLayer = _b[0], secondLayer = _b[1];
            var firstOpened = singleBorderRadiusShorthandOpenerInner(firstLayer, api);
            var secondOpened = secondLayer && secondLayer.length > 0
                ? singleBorderRadiusShorthandOpenerInner(secondLayer, api)
                : undefined;
            var opened = {};
            var props = Object.keys(firstOpened);
            try {
                for (var props_1 = tslib_1.__values(props), props_1_1 = props_1.next(); !props_1_1.done; props_1_1 = props_1.next()) {
                    var prop = props_1_1.value;
                    opened[prop] = [firstOpened[prop]];
                    if (secondOpened) {
                        opened[prop].push(secondOpened[prop]);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (props_1_1 && !props_1_1.done && (_a = props_1.return)) _a.call(props_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return opened;
        },
    });
    return function (shortHand, api) {
        var openedShorthand = borderRadiusShorthandOpener(shortHand, api);
        var layers = [];
        var currLayer;
        for (var i = 0; (currLayer = (0, shorthand_parser_utils_1.getOpenedLayer)(openedShorthand, i)) !==
            undefined; i++) {
            layers.push(currLayer);
        }
        return layers;
    };
};
exports.openBorderRadiusShorthand = openBorderRadiusShorthand;
var closeBorderRadiusShorthand = function () {
    return function (opened, api, detachExpression) {
        if (!opened[0]) {
            return [];
        }
        var borderRadiusLayerCloser = (0, shorthand_parser_utils_1.edgesShorthandCloser)('border-radius', true);
        var closedLayers = [];
        closedLayers = closedLayers.concat(borderRadiusLayerCloser(opened[0], api, detachExpression));
        if (opened[1]) {
            closedLayers = closedLayers.concat((0, tokenizers_1.valueTextNode)(css_data_types_1.INTERNAL_VALUE_SEPERATOR), borderRadiusLayerCloser(opened[1], api, detachExpression));
        }
        return (0, shorthand_parser_utils_1.fixAstNodesPositions)(closedLayers, api);
    };
};
exports.closeBorderRadiusShorthand = closeBorderRadiusShorthand;
//# sourceMappingURL=border-radius-shorthand.js.map